// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { decodeToken } from '../services/AuthService';
import { refreshToken } from '../api';

// Crear contexto
const AuthContext = createContext();

// Componente proveedor de contexto
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState(localStorage.getItem('token'));  // Usamos el token directamente aquí

    useEffect(() => {
        if (token) {
            setIsAuthenticated(true);
        }
    }, [token]);

    // Verificar si el token está a punto de expirar
    useEffect(() => {
        if (token) {
            const interval = setInterval(() => {
                if (isTokenExpiringSoon(token)) {
                    refreshToken();
                }
            }, 30000); // Comprobar cada 30s

            return () => clearInterval(interval); // Limpiar intervalo cuando el componente se desmonte
        }
    }, [token]);

    // Función para verificar si el token está a punto de expirar
    const isTokenExpiringSoon = (token) => {
        const decoded = decodeToken(token);

        if(!decoded)
        {
            return false;
        }

        const expirationTime = decoded.exp * 1000;  // Expiración en milisegundos
        const currentTime = Date.now();
        return expirationTime - currentTime < 1 * 60 * 1000; // 1 minuto antes de expirar
    };


    const login = (newToken) => {
        localStorage.setItem('token', newToken);
        setToken(newToken);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setToken(null);
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, token }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook personalizado para acceder al contexto de autenticación
export const useAuth = () => useContext(AuthContext);
